import { GenericTabViewModelImpl } from '../tabs/generictabviewmodel';


export class GridTabViewModelImpl extends GenericTabViewModelImpl
{
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/gridtabs/gridtabviewmodel.ts